export enum TransferStatusEnum {
  ARCHIVED = 'ARCHIVED',
}
